import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import * as actions from 'actions/response';
import { converter } from 'helpers/converter';
import * as metricsActions from 'action-creators/metrics';

const classButtonInactive = 'btn btn-default close-modal btn-block';

class ModalErrorSimple extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    // Set Metrics
    props.setMetricsEvent({
      type: 'executor',
      error: props.message,
    });
  }

  closeModal() {
    if (this.props.buttonCloseAction) {
      return this.props.buttonCloseAction();
    }
    return this.props.closeModal('ErrorSimple');
  }

  onAccept(e, cb) {
    e.preventDefault();
    if (!cb) {
      return this.closeModal();
    }
    const scope = this;
    return cb(scope);
  }

  onClose(e, cb) {
    e.preventDefault();
    if (!cb) {
      return this.closeModal();
    }
    const scope = this;
    return cb(scope);
  }

  render() {
    return (
      <Modal show={true}>
        <Modal.Header>
          {this.props.withClose && <Button
            className="close close-modal"
            onClick={e => this.onClose(e, this.props.onClose)}
          >
            x
          </Button>}
          <h4 className="text-center">{this.props.title}</h4>
        </Modal.Header>
        <Modal.Body className="text-center error">
          <i className="fa text-center fa-3x fa-times texto-blanco" />
          <p
            className="padding-top-2"
            dangerouslySetInnerHTML={{ __html: this.props.message }}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="footer-modal-button flex-end">
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12 padding-top-05">
              <Button
                className={classButtonInactive}
                onClick={e => this.onAccept(e, this.props.onAccept)}
              >
                {converter.convertApaUnicode(
                  this.props.translations,
                  'registro_aceptar',
                  this.props.acceptText,
                )}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalErrorSimple.defaultProps = {
  withClose: true,
  acceptText: 'Aceptar'
};

ModalErrorSimple.propTypes = {
  translations: PropTypes.object,
  buttonCloseAction: PropTypes.func,
  onAccept: PropTypes.func,
  setMetricsEvent: PropTypes.func,
  closeModal: PropTypes.func,
  onClose: PropTypes.func,
  message: PropTypes.string,
  title: PropTypes.string,
  withClose: PropTypes.bool,
  acceptText: PropTypes.string
};

const mapStateToProps = state => ({
  translations: state.translations,
  payload: state.metrics.payload,
});

const mapDispatchToProps = dispatch => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
  setMetricsEvent(options) {
    dispatch(metricsActions.setMetricsEvent(options));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalErrorSimple);
